import React from "react";
import PropTypes from "prop-types";
import "./styles.scss";
import Back from "../../../../assets/icons/back.svg";


const DocumentSideBarTitle = ({aidant, rdv, onclick}) => {

    return (
        <div className="titre-document">
            <div onClick={onclick} className="goBack"><img src={Back} alt="retour"/></div>
            <div>
                <h1><strong>Vos documents</strong></h1>
                <h2> {aidant ? `Pour ${aidant}` : ""} {rdv && <>Pour une prise de rendez-vous.</>}</h2>
            </div>
        </div>
    );
};

DocumentSideBarTitle.propTypes = {
    aidant: PropTypes.string,
    rdv: PropTypes.bool,
    onclick: PropTypes.func
};

export default DocumentSideBarTitle;